import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '@/modules/core/app/constants/api.constants';
import { GenericModel } from '@/modules/core/app/models/GenericModel';

export class WorkflowEstateStatusListResource extends BaseResource {
  getEstateStatusList(
    selectedJurisdictions: Array<number> = [],
    selectedEstateTypes: Array<string> = [],
    workflowType?: string
  ): Promise<Array<GenericModel>> {
    return this.getData(Route.WORKFLOWS_AVAILABLE_ESTATE_STATUSES, GenericModel, {
      selectedJurisdictions: selectedJurisdictions,
      selectedEstateTypes: selectedEstateTypes,
      workflowType: workflowType
    });
  }
}

export default new WorkflowEstateStatusListResource();
